import { SOGetEntity } from '../entity/so-get-entity';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENInterphaceType} from '../../enums';


export class SOPutInterphace {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public interphaceType: ENInterphaceType = null,
    public entity: SOGetEntity = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutInterphace(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'interphaceType' in params ? params.interphaceType : null,
      'entity' in params ? params.entity : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
